
<template>
  <div class="Home">
    <Navbar/> 
    <v-container class="grey lighten-5">
      <v-row>
        <v-col md="4">
          <v-card>
              <v-card-title class="headline">จำนวนเงินคงเหลือ</v-card-title>
              <v-card-subtitle>{{$store.getters.accountInfo}}</v-card-subtitle>
          </v-card>
        </v-col>
                <v-col md="4">
          <v-card>
              <v-card-title class="headline">จำนวนเงินคงเหลือ</v-card-title>
              <v-card-subtitle>1,000,000</v-card-subtitle>
          </v-card>
        </v-col>
        <v-col md="4">
          <v-card>
              <v-card-title class="headline">จำนวนเงินคงเหลือ</v-card-title>
              <v-card-subtitle>1,000,000</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <dattopuphist>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import {store} from '../store/store';
import Navbar from '../components/Navbar';
//import Topuphist from '../components/Topuphist';
import dattopuphist from '../components/datatable_tophist';
//import axios from 'axios';
//import qs from 'qs';
export default {
  name: 'Home',
  store,
  components:{
    Navbar,
    //Topuphist,
    dattopuphist
  },
  data () {
    return{
      info:[],
    }
  },
  mounted () {



  }

}
</script>
